import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { triggerTextStyles } from './styles/trigger-text.styles';
import type { TriggerTextPropsInterface } from './types/trigger-text.types';

/**
 * Inline trigger style used for `Tooltip` and `Popover` components in a body of text.
 *
 * `TriggerText` is normally used as a child of a `Popover.Trigger` or `Tooltip.Trigger`.
 *
 * @related ['Popover', 'Tooltip', 'TriggerButton']
 * @since 7.0.0
 */

export const TriggerText = forwardRef<HTMLButtonElement, TriggerTextPropsInterface>(
  (props: TriggerTextPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const styles = css(triggerTextStyles, cssProp);
    return (
      <button
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="TriggerText"
        className={cx('c11n', styles, className)}
        type="button"
        {...rest}
      >
        {children}
      </button>
    );
  },
);

TriggerText.displayName = 'TriggerText';
